import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { ROLE_CONSTANTS } from "@/modules/Roles/constants/RoleConstants";
import { InitialData } from "./../../models/InitialData";
import { View } from "./../../models/View";
import { Controller } from "./../../models/Controller";
import ViewButton from "@/shared/components/ViewButton/ViewButton.vue";
import { ReferenceDataAccess } from "../../models/ReferenceData";
import { Utils } from "@/shared/utils/utils";
@Component({
  name: "AssignPermissionCard",
  components: {
    ViewButton
  }
})
export default class AssignPermissionCard extends Vue {
  @Prop() referenceDataAccess!: ReferenceDataAccess;
  @Prop() viewsSelect!: View;
  @Prop() private currentData!: InitialData;
  @Prop({ default: false, required: false })
  public isModal!: boolean;
  flexCenterClass = "d-flex justify-center align-center";
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  card2Class = STYLE_CLASSES.CARD_PADING;
  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD_2;
  ROLE_CONST = ROLE_CONSTANTS.ASSIGN_PERMISSION_CARD;
  iscollapse = true;
  controllersTemp: Controller[] = [];
  controllersLocal: Controller[] = [];

  get newControllersLocal(): Controller[] {
    return !this.referenceDataAccess || !this.referenceDataAccess.controller
      ? []
      : this.viewsSelect.controllers.map(
          (name: string): Controller =>
            this.referenceDataAccess.controller?.find(
              (controller: Controller) => controller.id == name
            ) || new Controller()
        ) || [];
  }
  mounted() {
    this.updateControllersLocal();
    this.updateControllersTemp();
    if (this.referenceDataAccess.viewCurrent == this.viewsSelect.id) {
      Utils.scrollToElement(
        ROLE_CONSTANTS.CARD_VIEW + this.viewsSelect.id,
        this
      );
    }
  }

  @Watch("viewsSelect")
  @Watch("currentData")
  updateControllersTemp() {
    this.controllersTemp = this.controllersLocal.map(controller => {
      let newController = this.currentData.controllersList.find(
        oldController => oldController.id == controller.id
      );
      if (!newController) {
        newController = {
          ...controller,
          getId: "",
          postId: "",
          deleteId: "",
          putId: ""
        };
      }

      return { ...newController };
    });
  }
  @Watch("viewsSelect")
  @Watch("referenceDataAccess")
  updateControllersLocal() {
    this.controllersLocal = this.newControllersLocal;
  }

  get parentView(): View | void {
    if (
      !this.referenceDataAccess ||
      !this.referenceDataAccess.principal ||
      !this.viewsSelect ||
      !this.viewsSelect.parentView
    ) {
      return;
    }
    return this.referenceDataAccess.principal.find(
      view => view.id == this.viewsSelect.parentView
    );
  }

  deleteView() {
    this.$emit("deleteCurrenData", this.controllersTemp);
  }

  get canEdit() {
    return this.referenceDataAccess.viewCurrent == "";
  }

  get isEdit() {
    return this.referenceDataAccess.viewCurrent == this.viewsSelect.id;
  }

  changeEdit() {
    this.$emit("onChangeEdit", this.isEdit ? "" : this.viewsSelect.id);
  }

  onCancel() {
    this.iscollapse = true;
    this.updateControllersTemp();
    this.changeEdit();
  }

  valueTrueCheckBox(id: string, field: string): string {
    const controller = this.controllersLocal.find(
      controller => controller.id == id
    );

    if (
      !controller ||
      !Object.prototype.hasOwnProperty.call(controller, field)
    ) {
      return "";
    }
    switch (field) {
      case "postId":
        return controller.postId;
      case "getId":
        return controller.getId;
      case "putId":
        return controller.putId;
      case "deleteId":
        return controller.deleteId;
      default:
        return "";
    }
  }

  onSave() {
    this.iscollapse = true;
    this.controllersTemp = this.controllersTemp.map(controller => {
      if (
        controller.getId &&
        controller.postId &&
        controller.deleteId &&
        controller.putId
      ) {
        const controllerTemp = this.controllersLocal.find(
          con => con.id == controller.id
        );

        if (controllerTemp) {
          controller.allId = controllerTemp.allId;
        }
      } else {
        controller.allId = "";
      }
      return controller;
    });

    this.$emit("update:controllers", this.controllersTemp);

    this.changeEdit();
  }
  get saveDisabled(): boolean {
    if (this.controllersTemp.length == 0) {
      return false;
    }
    const index = this.controllersTemp.findIndex(
      controller =>
        controller.getId ||
        controller.postId ||
        controller.deleteId ||
        controller.putId
    );
    return index == -1;
  }
}
